<template>
  <div>
    <QHeader class="bg-primary text-white">
      <QToolbar>
        <QBtn flat round dense icon="icon-f-arrow-left" @click="goBack" />
        <QToolbarTitle>
          {{ $t("ETAB.PAGES.PAYMENT.PAYMENT_MEANS.@TITLE") }}
        </QToolbarTitle>
      </QToolbar>
    </QHeader>

    <QPageContainer>
      <QPage padding class="payment-means-component">
        <PaymentCards :cards-collection="cardsCollection" @on-add-bank-card="goToBankCardPage" @bank-card-action="openModal" />
      </QPage>
    </QPageContainer>

    <QFooter class="bg-primary-ultra-light text-primary">
      <LogoDescription :logo="require('@etab/assets/img/logo.png')" :description="$t('ETAB.PAGES.PAYMENT.PAYMENT_MEANS.@NOTICE')" />
    </QFooter>
    <ConfirmActionModal v-model:opened="isModalOpened" @confirm-action="deleteCardAction(selectedBankCard)">
      <template #body>
        <p>{{ $t("QUESTIONS.@CONFIRM_ACTION") }}</p>
      </template>
    </ConfirmActionModal>
  </div>
</template>
<script>
  import { mapState } from "pinia";
  import { StatusBar } from "@core/plugins/mobile";
  import { CardsCollectionModel, CardModel } from "@core/models";
  import { NotificationsManager } from "@core/managers/notifications.manager";
  import { PaymentService } from "@core/services";
  import { ConfirmActionModal } from "@core/components/modals";

  import { ETAB_ROUTES } from "@etab/config";
  import { useProfileStore } from "@etab/stores/profile";
  import { GETTER_PROFILE_GET } from "@etab/stores/types";
  import PaymentCards from "@etab/components/payment/PaymentCards.component.vue";

  export default {
    components: {
      PaymentCards,
      ConfirmActionModal,
    },
    data() {
      return {
        isModalOpened: false,
        loadingAdminFolder: false,
        cardsCollection: new CardsCollectionModel({ cards: [] }),
        selectedBankCard: new CardModel(),
      };
    },
    computed: {
      ...mapState(useProfileStore, {
        profile: GETTER_PROFILE_GET,
      }),
      isProfileLoaded() {
        return this.profile.isProfileLoaded();
      },
      credit() {
        return this.profile.getCredit();
      },
    },
    created() {
      StatusBar.setPrimaryBackground();
      this.initMeansOfPayment();
    },
    methods: {
      async initMeansOfPayment() {
        try {
          this.$_startGlobalLoading();
          await this.refreshCardsCollection();
        } catch (error) {
          NotificationsManager.contactEtabSupport();
          throw error;
        } finally {
          this.$_stopGlobalLoading();
        }
      },
      async refreshCardsCollection() {
        const cards = await PaymentService.getCards();
        this.cardsCollection = new CardsCollectionModel({ cards });
      },
      async deleteCardAction(card) {
        try {
          this.$_startGlobalLoading();
          await PaymentService.deleteCard({ cardId: card.getId() });
          await this.refreshCardsCollection();
        } catch (error) {
          NotificationsManager.contactEtabSupport();
          throw error;
        } finally {
          this.$_stopGlobalLoading();
        }
      },
      openModal(bankCard) {
        this.isModalOpened = true;
        this.selectedBankCard = bankCard;
      },
      goBack() {
        this.$router.push({ name: ETAB_ROUTES.account.adminFolderStatus.name }).catch((suppressedError) => {});
        StatusBar.setDefault();
      },
      goToBankCardPage() {
        this.$router.push({ name: ETAB_ROUTES.payment.addCard.name }).catch((suppressedError) => {});
      },
    },
  };
</script>
<style lang="scss">
  .payment-means-component {
    > section {
      padding: 15px;

      > h3 {
        margin: 0px;
      }

      > .q-btn {
        margin-top: 15px;
      }
    }
  }
</style>
